import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { styleMultiLevelCategoryList } from "./styles";
import {
  Collapse,
  List,
  ListItemSecondaryAction,
  ListItemText,
  ListItem,
  ListItemIcon,
  Checkbox,
  IconButton,
} from "@material-ui/core";
import {
  Folder,
  ExpandLess,
  ExpandMore,
  VisibilityOff,
  Settings,
  Home,
} from "@material-ui/icons";
import Loading from "../loading";
export class MultiLevelCategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "",
      noRecordCategory: true,
      collapse: [],
      selected: [],
    };
  }
  async componentDidMount() {
    // this.getProductCategory();
    if (this.props.defaultSelected && !this.props.multiCheck)
      this.setState({
        selectedCategory: this.props.defaultSelected,
      });
    else if (this.props.defaultSelected && this.props.multiCheck)
      this.setState({
        selected: this.props.defaultSelected,
      });
  }
  getProductCategory = async () => {
    this.loading.startLoading();
    let result = await this.props.getProductCategory();
    if (result && Array.isArray(result) && result.length !== 0) {
      this.setState({ noRecordCategory: false });
    }
    this.loading.stopLoading();
  };
  handleOpenCollapes(id) {
    const collapse = this.state.collapse;
    if (collapse.indexOf(id) !== -1) collapse.splice(collapse.indexOf(id), 1);
    else collapse.push(id);
    this.setState(collapse);
  }
  handleListItem = (item = {}) => {
    this.setState({ selectedCategory: item.id || "" });
    if (this.props.handleListItem) this.props.handleListItem(item.id);
  };
  handleClick = (item) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(item.id);
    let subMenu = [];
    let newSelected = [];
    if (selectedIndex === -1) {
      subMenu = subMenu.concat(selected, item.id, this.getIdSubMenu(item));
      subMenu.forEach((element) => {
        if (!this.isExist(newSelected, element)) newSelected.push(element);
      });
    } else {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
      subMenu = this.getIdSubMenu(item);
      subMenu.forEach((element) => {
        if (newSelected.indexOf(element) !== -1) {
          newSelected = newSelected
            .slice(0, newSelected.indexOf(element))
            .concat(newSelected.slice(newSelected.indexOf(element) + 1));
        }
      });
    }
    if (this.props.handleSelect) this.props.handleSelect(newSelected);
    this.setState({ selected: newSelected });
  };
  getIdSubMenu = (item) => {
    let newSelected = [];
    if (Array.isArray(item.subMenu) && item.subMenu.length > 0) {
      item.subMenu.forEach((element) => {
        newSelected = newSelected.concat(element.id);
        newSelected = newSelected.concat(this.getIdSubMenu(element));
      });
    }
    return newSelected;
  };
  isExist = (newSelected, x) => newSelected.indexOf(x) > -1;
  renderItem = (item, menuLevel) => {
    const { classes, multiCheck = false } = this.props;
    const { selected, collapse, selectedCategory } = this.state;
    const isSelected = selected.indexOf(item.id) >= 0 ? true : false;

    return [
      <ListItem
        style={{ cursor: "pointer", paddingLeft: `${menuLevel * 16}px` }}
        key={`menu-${item.id}`}
        role={undefined}
        divider={false}
        className={selectedCategory === item.id ? classes.selectedItem : ""}
        onClick={() => this.handleListItem(item)}
      >
        {multiCheck && (
          <Checkbox
            onClick={() => this.handleClick(item)}
            checked={isSelected}
            tabIndex={-1}
            disableRipple
          />
        )}
        <ListItemIcon>
          {item.enabled ? <Folder /> : <VisibilityOff />}
        </ListItemIcon>
        <ListItemText
          dense="true"
          primary={`${item.name}`}
          className={classes.menuName}
        />
        <ListItemSecondaryAction>
          {item.subMenu && item.subMenu.length ? (
            <IconButton onClick={() => this.handleOpenCollapes(item.id)}>
              {collapse.indexOf(item.id) != -1 ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </IconButton>
          ) : (
            ""
          )}
        </ListItemSecondaryAction>
      </ListItem>,
      <Collapse
        in={collapse.indexOf(item.id) != -1}
        key={`collapse-${item.id}`}
      >
        {Array.isArray(item.subMenu) &&
          item.subMenu.length > 0 &&
          item.subMenu.map((item) => {
            return this.renderItem(item, menuLevel + 1);
          })}
      </Collapse>,
    ];
  };
  handleManageCategory = () => {
    if (this.props.history) this.props.history.push("/productMenu/category");
  };
  render() {
    const {
      t,
      classes,
      listProductCategory = [],
      showManage = false,
      showAll = false,
      showOnModal = false,
      showRoot = false,
      hidedId = "",
    } = this.props;
    let { selectedCategory = {} } = this.state;
    return (
      <>
        <Loading onRef={(id) => (this.loading = id)} />
        <List
          component="nav"
          aria-label="main mailbox folders"
          className={showOnModal ? classes.list : classes.custom}
        >
          {showAll && (
            <ListItem
              button
              className={!selectedCategory ? classes.selectedItem : ""}
              onClick={() => this.handleListItem()}
            >
              {/* <Checkbox
                       onClick={() => this.handleClick(item)}
                       checked={isSelected}
                       tabIndex={-1}
                       disableRipple
                     /> */}
              <ListItemIcon>
                <Folder />
              </ListItemIcon>
              <ListItemText primary={t("product_all_product")} />
            </ListItem>
          )}
          {showRoot && (
            <ListItem
              button
              className={!selectedCategory ? classes.selectedItem : ""}
              onClick={() => this.handleListItem()}
            >
              {/* <Checkbox
                       onClick={() => this.handleClick(item)}
                       checked={isSelected}
                       tabIndex={-1}
                       disableRipple
                     /> */}
              <ListItemIcon>
                <Home />
              </ListItemIcon>
              <ListItemText primary={t("product_product_category_root")} />
            </ListItem>
          )}
          {listProductCategory
            //  .sort(this.getSorting(order, orderBy))
            .map((row, index) => {
              if (row.id != hidedId) return this.renderItem(row, 1);
            })}
          {showManage && (
            <ListItem button onClick={() => this.handleManageCategory()}>
              <ListItemIcon>
                <Settings />
              </ListItemIcon>
              <ListItemText primary={t("product_manage_product_category")} />
            </ListItem>
          )}
        </List>
      </>
    );
  }
}

const mapState = (state) => ({
  listProductCategory: state.productCategory.listProductCategory,
});

const mapDispatch = (dispatch) => ({
  getProductCategory: dispatch.productCategory.getProductCategory,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styleMultiLevelCategoryList, { withTheme: 0 })(
      MultiLevelCategoryList
    )
  )
);
